import React, { useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';

import metadata from './EntryPage.metadata.json5';
import metadataEmpty from './EntryPageEmpty.metadata.json5';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW'
};

const { applicationDetails } = appConfig;

function EntryPage({ history }) {
    const auth = useAuthentication();
    const [view, updateView] = useState(VIEWS.logInView);
    const { state } = history.location;

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    const refreshPage = useCallback(() => {
        window.location = '/claimshub';
    },[]);

    if (auth.isAuthInProgress) {
        return <Loader loaded={!auth.isAuthInProgress} />;
    }
    
    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/claims'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        },
        returnToClaimshub:{
            onClick: refreshPage
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignInClick: handleSignInClick
        }
    };

    const renderedContentFromMetadata = (
        <div>
            {renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}
        </div>
    );
    const renderedContentFromEmptyMetadata=(
        <div>
            {renderContentFromMetadata(metadataEmpty.pageContent, overrideProps, resolvers)}
        </div>
    );
   if(auth.isLoggedOut !==undefined && auth.isLoggedOut){      
    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
        />
    );
   }else{
    return renderedContentFromEmptyMetadata;
   }
}

EntryPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default withRouter(EntryPage);
